import { HubsSettingClient } from 'frontend-preferences-client';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getGovernanceStatusRpc } from '../../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingGovernanceRpc';
import { ENRICHMENT_SETTINGS, ENRICHMENT_SETTINGS_KEYS, getKey, getApiKey } from './enrichmentSettings';
import { transformFeatureStates } from './transforms';
const hubsSettingClient = HubsSettingClient.forCaller('enrichment-settings-ui');
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const isSettingTrue = value => value === 'true';

/**
 * Default settings to pass to fetchEnrichmentSettings to initialize settings
 *
 * @returns {DefaultSettings} with API key and default value of 'false'
 *
 * @example
 * const defaultFetchSettings = {
 *  'enrichment:auto-hydrate': 'false',
 *  'enrichment:contacts-auto-hydrate: 'false'
 * };
 */
const defaultFetchSettings = ENRICHMENT_SETTINGS_KEYS.reduce((acc, key) => {
  acc[ENRICHMENT_SETTINGS[key]] = 'false';
  return acc;
}, {});
export async function fetchEnrichmentSettings() {
  const results = await hubsSettingClient.batchFetch(defaultFetchSettings);
  const resultsKeys = Object.keys(results);

  /**
   * Transform the results from the HubsSettingClient to settings keys
   * with boolean values.
   *
   * @returns {SettingsData} An object where each key corresponds to
   * an enrichment setting key with boolean value.
   * @example
   * const data = {
   *  companyEnrichmentAuto: true,
   *  contactEnrichmentManual: false
   * };
   */
  const data = resultsKeys.reduce((acc, apiKey) => {
    const key = getKey(apiKey);
    acc[key] = isSettingTrue(results[apiKey]);
    return acc;
  }, {});
  return data;
}
export async function fetchFeatureStates() {
  const data = await rpcClient.call(getGovernanceStatusRpc, {
    request: {}
  });
  return transformFeatureStates(data);
}
export async function updateEnrichmentSetting({
  key,
  value
}) {
  const valueString = value ? 'true' : 'false';
  const apiKey = getApiKey(key);
  await hubsSettingClient.write(apiKey, valueString);
  return {
    key,
    value
  };
}